import { createHead } from "@unhead/vue/client";
import { createPinia } from "pinia";
import { type App } from "vue";

import { TableauManager } from "@vm/tableau";
import { vueUiPlugin } from "@vm/tui";

import appConfig from "@/config/app.config";
import tableauConfig from "@/config/tableau.config";

import { logger } from "@/logger";
import router from "@/router";

export const pinia = createPinia();
export async function bootApp(app: App) {
  try {
    if (appConfig.enableTableau) {
      try {
        await TableauManager.initialize(tableauConfig);
        console.log("TableauManager initialized successfully.");
      } catch (error) {
        logger.error("Error during TableauManager initialization:", error);
      }
    }
    const head = createHead();

    app.use(head);
    app.use(router);
    app.use(pinia);
    app.use(vueUiPlugin);
  } catch (error) {
    console.error("Error during app bootstrapping:", error);
  }
}
